import type { SVGProps } from 'react'

export const PenIcon: { __brand: 'color' | 'nocolor' } = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M8.51932 2.25H5.83654C3.63444 2.25 2.25293 3.81094 2.25293 6.01961V11.9797C2.25293 14.189 3.62787 15.75 5.83654 15.75H12.1627C14.3736 15.75 15.7471 14.189 15.7471 11.9797V9.29393"
        stroke="var(--color-icon-base-default, #707070)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.91846 10.8902L9.87104 10.7304C10.3831 10.6444 10.8507 10.3869 11.1964 10.0003L15.303 5.51881C15.7939 4.98852 15.7618 4.16137 15.2315 3.67047L14.3555 2.85936C13.8253 2.36919 12.9973 2.40129 12.5072 2.93084L8.35536 7.46269C8.03736 7.81864 7.83891 8.26504 7.78716 8.73986L7.68066 9.72244C7.60476 10.4256 8.22111 11.0069 8.91846 10.8902Z"
        stroke="var(--color-icon-base-default, #707070)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

PenIcon.__brand = 'nocolor'
